<template>
    <div ref="calendar" id="calendar"></div>
</template>

<style>
.fc-sun {
  color: red;
}
.fc-sat {
  color: blue;
}
.fc-ltr .fc-basic-view .fc-day-top .fc-day-number {
  float: left;
}
</style>

<script>
    import defaultsDeep from 'lodash.defaultsdeep'
    import 'fullcalendar'
    import $ from 'jquery'

    export default {
        name: 'full-calendar',
        props: {
            events: {
                default() {
                    return []
                },
            },
            eventSources: {
                default() {
                    return []
                },
            },
            editable: {
                default() {
                    return true
                },
            },
            selectable: {
                default() {
                    return true
                },
            },
            selectHelper: {
                default() {
                    return true
                },
            },
            header: {
                default() {
                    return {
                        // prev,next today,title,month,agendaWeek,agendaDay
                        left:   'today prev next title',
                        center: '',
                        right:  ''
                    }
                },
            },
            defaultView: {
                default() {
                    return 'month'
                },
            },
            sync: {
                default() {
                    return false
                }
            },
            config: {
                type: Object,
                default() {
                    return {}
                },
            },
        },
        data() {
            return {
                eventList: []
            }
        },
        computed: {
            defaultConfig() {
                const self = this
                return {
                    header: this.header,
                    height: 700,
                    defaultView: this.defaultView,
                    editable: this.editable,
                    selectable: this.selectable,
                    selectHelper: this.selectHelper,
                    aspectRatio: 2,
                    timeFormat: 'HH:mm',
                    events: this.eventList,
                    eventSources: this.eventSources,
                    eventRender(event, element, view) {
                        if (this.sync) {
                            self.events = cal.fullCalendar('clientEvents')
                        }
                        element.find('.fc-title').attr('title', event.title)
                        self.$emit('event-render', event, element, view)
                    },
                    eventDestroy(event) {
                        if (this.sync) {
                            self.events = cal.fullCalendar('clientEvents')
                        }
                    },
                    eventClick(...args) {
                        self.$emit('event-selected', ...args)
                    },
                    eventDrop(...args) {
                        self.$emit('event-drop', ...args)
                    },
                    eventResize(...args) {
                        self.$emit('event-resize', ...args)
                    },
                    dayClick(...args){
                        self.$emit('day-click', ...args)
                    },
                    viewRender(...args){
                        self.$emit('view-render', ...args)
                    },
                    views: {
                        month: {
                            titleFormat: 'YYYY年M月'
                        }
                    },
                    buttonText: {
                        // prev:     '<',
                        // next:     '>',
                        // prevYear: '<<',
                        // nextYear: '>>',
                        today:    '今日',
                        // month:    '月',
                        // week:     '週',
                        // day:      '日'
                    },
                    monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
                    dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
                    select(start, end, jsEvent, view, resource) {
                        self.$emit('event-created', {
                            start,
                            end,
                            allDay: !start.hasTime() && !end.hasTime(),
                            view,
                            resource
                        })
                    }
                }
            },
        },
        mounted() {
            const cal = $(this.$el),
                self = this
            this.$on('remove-event', (event) => {
                if(event && event.hasOwnProperty('id')){
                    $(this.$el).fullCalendar('removeEvents', event.id);
                }else{
                    $(this.$el).fullCalendar('removeEvents', event);
                }
            })
            this.$on('rerender-events', () => {
                $(this.$el).fullCalendar('rerenderEvents')
            })
            this.$on('refetch-events', () => {
                $(this.$el).fullCalendar('refetchEvents')
            })
            this.$on('render-event', (event) => {
                $(this.$el).fullCalendar('renderEvent', event)
            })
            this.$on('reload-events', () => {
                $(this.$el).fullCalendar('removeEvents')
                // $(this.$el).fullCalendar('addEventSource', this.events)
                $(this.$el).fullCalendar('addEventSource', this.eventList)
            })
            this.$on('rebuild-sources', () => {
                $(this.$el).fullCalendar('removeEvents')
                this.eventSources.map(event => {
                    $(this.$el).fullCalendar('addEventSource', event)
                })
            })
            cal.fullCalendar(defaultsDeep(this.config, this.defaultConfig))
        },
        methods: {
            fireMethod(...options) {
                return $(this.$el).fullCalendar(...options)
            },
        },
        watch: {
            events: {
                deep: true,
                handler(val) {
                    this.eventList = JSON.parse(JSON.stringify(val))
                    $(this.$el).fullCalendar('removeEventSources')
                    $(this.$el).fullCalendar('addEventSource', this.eventList)
                },
            },
            eventSources: {
                deep: true,
                handler(val) {
                    this.$emit('rebuild-sources')
                },
            },
        },
        beforeDestroy() {
            this.$off('remove-event')
            this.$off('rerender-events')
            this.$off('refetch-events')
            this.$off('render-event')
            this.$off('reload-events')
            this.$off('rebuild-sources')
        },
    }
</script>



// WEBPACK FOOTER //
// src/assets/js/components/operator/FullCalendar.vue